import { render, staticRenderFns } from "./shipping-form.vue?vue&type=template&id=2b56b6b4&scoped=true"
import script from "./shipping-form.vue?vue&type=script&lang=js"
export * from "./shipping-form.vue?vue&type=script&lang=js"
import style0 from "./shipping-form.vue?vue&type=style&index=0&id=2b56b6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56b6b4",
  null
  
)

export default component.exports